import React, { memo } from "react";

import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import DebugOverlay from "../DebugOverlay/DebugOverlay";
import VersionDisplay from "../VersionDisplay/VersionDisplay";
import ViewPort from "../elements/ViewPort/ViewPort";
import "./Layout.scss";

interface ILayout {
	children?: React.ReactNode;
}

const Layout: React.FC<ILayout> = ({ children }) => {
	const { state: devMode } = useConfigContext((state) => state.devMode);

	return (
		<ViewPort container className="LayoutWrapper" direction="column" data-testid="HomePageCntr">
			{devMode && <DebugOverlay />}
			<VersionDisplay />
			<div className="LayoutContent">{children}</div>
		</ViewPort>
	);
};

export default memo(Layout);
